import React, { useState, useEffect } from "react";
import { Plus, Edit2, Trash2, Save } from "lucide-react";
import { Card, Btn, Input, Pagination, usePagination } from "../../../components/UI";
import { useToast } from "../../../components/Toast";

const selStyle = {
  width:"100%", padding:"8px 12px", border:"1.5px solid #E5E7EB", borderRadius:8,
  fontSize:13, outline:"none", boxSizing:"border-box", fontFamily:"inherit", background:"white",
};

const SimpleCrudTab = ({ title, items, addFn, updFn, delFn, onRefresh,
  fields = [{ key:"nama", label:"Nama", placeholder:"Nama..." }],
  extraCols = [] }) => {

  const [editId, setEditId]   = useState(null);
  const [editVal, setEditVal] = useState({});
  const [newVal, setNewVal]   = useState({});
  const { toast: showToast }  = useToast();
  const { page, setPage, pageSize, setPageSize, reset, paginate } = usePagination(10);
  useEffect(() => { reset(); }, [items]);

  const save = async () => {
    const missingField = fields.find(f => f.required && !newVal[f.key]);
    if (missingField) { showToast(`${missingField.label} wajib diisi`, "error"); return; }
    try { await addFn(newVal); setNewVal({}); onRefresh(); showToast("Data ditambahkan"); }
    catch(e) { showToast(e.message, "error"); }
  };

  const update = async (id) => {
    try { await updFn(id, editVal); setEditId(null); onRefresh(); showToast("Data diperbarui"); }
    catch(e) { showToast(e.message, "error"); }
  };

  const del = async (id) => {
    if (!window.confirm("Hapus data ini?")) return;
    try { await delFn(id); onRefresh(); showToast("Data dihapus"); }
    catch(e) { showToast(e.message, "error"); }
  };

  return (
    <>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <h2 style={{ margin:0, fontSize:16, fontWeight:700, color:"#111827" }}>{title}</h2>
        <span style={{ fontSize:12, color:"#6B7280" }}>{items.length} data</span>
      </div>

      <Card style={{ marginBottom:16 }}>
        <p style={{ margin:"0 0 10px", fontSize:12, fontWeight:600, color:"#374151" }}>Tambah Data Baru</p>
        <div style={{ display:"flex", gap:10, alignItems:"flex-end" }}>
          {fields.map(f => (
            <div key={f.key} style={{ flex:1 }}>
              {f.type === "select" ? (
                <select value={newVal[f.key]||""} onChange={e => setNewVal(v => ({...v, [f.key]:e.target.value}))} style={selStyle}>
                  <option value="">— {f.label} —</option>
                  {f.options.map(o => <option key={o.id} value={o.id}>{o.nama}</option>)}
                </select>
              ) : (
                <Input value={newVal[f.key]||""} onChange={e => setNewVal(v => ({...v, [f.key]:e.target.value}))}
                  placeholder={f.placeholder || f.label}/>
              )}
            </div>
          ))}
          <Btn icon={<Plus size={13}/>} onClick={save}>Tambah</Btn>
        </div>
      </Card>

      <Card style={{ padding:0, overflow:"hidden" }}>
        {(() => { const { data: pagedItems, total, totalPages, from, to } = paginate(items); return (<>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
          <thead>
            <tr style={{ borderBottom:"1px solid #E5E7EB", background:"#F9FAFB" }}>
              <th style={{ padding:"10px 14px", textAlign:"left", fontSize:11, fontWeight:700, color:"#6B7280" }}>No</th>
              {fields.map(f => (
                <th key={f.key} style={{ padding:"10px 14px", textAlign:"left", fontSize:11, fontWeight:700, color:"#6B7280" }}>{f.label}</th>
              ))}
              {extraCols.map(c => (
                <th key={c.key} style={{ padding:"10px 14px", textAlign:"left", fontSize:11, fontWeight:700, color:"#6B7280" }}>{c.label}</th>
              ))}
              <th style={{ padding:"10px 14px", textAlign:"left", fontSize:11, fontWeight:700, color:"#6B7280" }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {pagedItems.length === 0 ? (
              <tr><td colSpan={fields.length + extraCols.length + 2} style={{ padding:32, textAlign:"center", color:"#9CA3AF", fontSize:13 }}>Belum ada data</td></tr>
            ) : pagedItems.map((item, i) => (
              <tr key={item.id} style={{ borderBottom:"1px solid #F3F4F6", background:i%2===0?"white":"#FAFAFA" }}>
                <td style={{ padding:"10px 14px", color:"#9CA3AF", fontSize:12 }}>{from + i}</td>
                {fields.map(f => (
                  <td key={f.key} style={{ padding:"10px 14px", color:"#374151" }}>
                    {editId === item.id ? (
                      f.type === "select" ? (
                        <select value={editVal[f.key]||""} onChange={e => setEditVal(v => ({...v,[f.key]:e.target.value}))} style={selStyle}>
                          <option value="">— {f.label} —</option>
                          {f.options.map(o => <option key={o.id} value={o.id}>{o.nama}</option>)}
                        </select>
                      ) : (
                        <Input value={editVal[f.key]||""} onChange={e => setEditVal(v => ({...v,[f.key]:e.target.value}))}/>
                      )
                    ) : (
                      f.type === "select"
                        ? (f.options.find(o => o.id === item[f.key])?.nama || item[`${f.key.replace('_id','')}_nama`] || "—")
                        : (item[f.key] || "—")
                    )}
                  </td>
                ))}
                {extraCols.map(c => (
                  <td key={c.key} style={{ padding:"10px 14px", color:"#9CA3AF", fontSize:12 }}>{item[c.key] || "—"}</td>
                ))}
                <td style={{ padding:"10px 14px" }}>
                  {editId === item.id ? (
                    <div style={{ display:"flex", gap:6 }}>
                      <Btn size="sm" icon={<Save size={12}/>} onClick={() => update(item.id)}>Simpan</Btn>
                      <Btn size="sm" variant="ghost" onClick={() => setEditId(null)}>Batal</Btn>
                    </div>
                  ) : (
                    <div style={{ display:"flex", gap:6 }}>
                      <Btn size="sm" variant="ghost" icon={<Edit2 size={12}/>}
                        onClick={() => { setEditId(item.id); setEditVal({...item}); }}/>
                      <Btn size="sm" variant="danger" icon={<Trash2 size={12}/>} onClick={() => del(item.id)}/>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ padding:"0 0 4px" }}>
          <Pagination page={page} totalPages={totalPages} total={total} from={from} to={to} pageSize={pageSize} onPageChange={setPage} onPageSizeChange={setPageSize} />
        </div>
        </>); })()}
      </Card>
    </>
  );
};

export default SimpleCrudTab;
